import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const StreamliningProcesses = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h1 className="banner-title">Streamlining Processes</h1>
          <p>
            Unlock operational efficiency with our solutions designed to
            streamline your workflows, <br /> reduce bottlenecks, and increase
            productivity. From automation to process optimization, we help
            businesses achieve more with less effort.
          </p>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/one-person-typing-futuristic-glowing-computer-generated-by-ai_188544-13364.jpg"
          alt="Streamlining Processes"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center">Overview</h2>
              <p className="text-center">
                Streamlining processes is the backbone of any successful
                business. With our cutting-edge solutions, we help organizations
                eliminate inefficiencies, automate repetitive tasks, and enhance
                overall productivity.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid bg-light" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Case Studies</h2>
              <p className="text-center mb-0">
                Discover how our process optimization solutions have transformed
                businesses and enhanced their operational efficiency.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">
                Inventory Management Optimization
              </h4>
              <p className="mb-4">
                By implementing AI-powered inventory management, we reduced
                stockouts by 40% and minimized overstocking by improving demand
                forecasting accuracy. The streamlined process improved cash flow
                and reduced waste.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Customer Support Automation</h4>
              <p className="mb-4">
                We implemented AI chatbots and automated ticket routing for a
                global tech company. This resulted in faster customer service
                response times, a 30% reduction in support staff workload, and
                increased customer satisfaction.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 bg-black text-white mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2>Ready to Streamline Your Processes?</h2>
                <p className="mt-3">
                  Contact us today to discover how our solutions can help you
                  optimize operations, automate processes, and increase
                  productivity.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Process Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StreamliningProcesses;
